module.exports = __webpack_public_path__ + "static/media/uae-flag1.b9fc2782.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/uae-flag1.svg
// module id = 1102
// module chunks = 2